import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import GetMobileNumber from './steps/getMobileNumber';
import SetNewPassword from './steps/setNewPassword';
import SetVerificationCode from './steps/setVerificationCode';
import '../auth/login.scss';
import RseeLogo from '../../assets/images/logo/rsee.png';

class ForgetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      resetPassToken: '',
      mobileNumber: ''
    };
  }

  setMobileNumber = mobileNumber => {
    this.setState({ mobileNumber });
  };

  changeStep = step => {
    this.setState({ step });
  };
  setTokens = token => {
    this.setState({ resetPassToken: token });
  };

  renderSteps = () => {
    switch (this.state.step) {
      case 1: {
        return (
          <GetMobileNumber
            setMobileNumber={this.setMobileNumber}
            mobileNumber={this.state.mobileNumber}
            changeStep={this.changeStep}
          />
        );
      }
      case 2: {
        return (
          <SetVerificationCode
            changeStep={this.changeStep}
            setTokens={this.setTokens}
            setVerificationCode={this.setVerificationCode}
            mobileNumber={this.state.mobileNumber}
          />
        );
      }
      case 3: {
        return (
          <SetNewPassword
            mobileNumber={this.state.mobileNumber}
            changeStep={this.changeStep}
            resetPassToken={this.state.resetPassToken}
          />
        );
      }
      default:
        break;
    }
  };

  render() {
    return (
      <div className="col m-0 p-0 main-content main-image w-100 ">
        <div className="d-flex flex-column align-items-center justify-content-center h-100">
          <img src={RseeLogo} />
          <div className="col-4 px-3 pb-2 card login-bg">
            <div className="col-12 d-flex justify-content-end align-items-center my-1 p-0">
              <Link to="/login" className="btn btn-success">
                {locales('titles.backToLogin')}
              </Link>
            </div>
            {this.renderSteps()}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = dispatch => {
  return {};
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ForgetPassword)
);
